<template>
  <div class="WRAPPER">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'blueprint-wrapper',
};
</script>

<style lang="scss" scoped>
.WRAPPER {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
